import { render } from "./Fotter.vue?vue&type=template&id=8291b386"
const script = {}

import "./Fotter.vue?vue&type=style&index=0&id=8291b386&lang=css"

import exportComponent from "C:\\Users\\toru-ota\\source\\repos\\Marron\\Jarvis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__